import { render, staticRenderFns } from "./SrListItemAvatar.vue?vue&type=template&id=0392d705"
import script from "./SrListItemAvatar.vue?vue&type=script&lang=js"
export * from "./SrListItemAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports